import { ModalidadI } from "interfaces/Modalidad";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { ModalidadRow } from "./ModalidadRow";

interface Props {
  elementos: ModalidadI[];
  renderActions?: (elemento: ModalidadI) => ReactNode;
}

export const ModalidadTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "50px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <ModalidadRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Modalidades para visualizar.</b> Para poder
                  visualizar modalidades debes <br /> seleccionar el botón
                  agregar «Nueva Modalidad».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
